module.exports = "<p>\n  data works!\n</p>\n<button class=\"btn btn-default\" (click)=\"addData()\">Yum</button>"